import {apiFetch} from 'lib/fetch'
import type {ContractTemplate} from 'types/contractTemplate'
import {getApiUrl} from '../urls'

export const list = async (): Promise<ContractTemplate[]> =>
  apiFetch.get<ContractTemplate[]>(getApiUrl('contractTemplates'), {
    simple: 'true',
  })
